import { PaymentMethod } from '@frontend/api-payment-plans';
import { useTranslation } from '@frontend/i18n';
import { classNames } from '@frontend/string';
import { Button, Heading } from '@frontend/design-system';
import { VerticalGrid } from '../containers/vertical-grid';
import { PaymentMethodListAch, PaymentMethodListAchProps } from './payment-methods-list-ach';
import { PaymentMethodListCard } from './payment-methods-list-card';

type AchProps = Omit<
  PaymentMethodListAchProps,
  'isLoading' | 'selectedPaymentMethod' | 'onSelectPaymentMethod' | 'onClickDelete'
>;

export type PaymentMethodListUIProps = {
  showAchList?: boolean;
  isLoading: boolean;
  addAchEnabled?: boolean;
  addCardButton?: React.ReactNode;
  addAchButton?: React.ReactNode;
  onClickAddCard?: () => void;
  onClickAddAch?: () => void;
  className?: string;

  /**
   * Shared Props
   */
  selectedPaymentMethod: PaymentMethod | null;
  onSelectPaymentMethod: (pm: PaymentMethod) => void;
  onClickDelete: (pm: PaymentMethod) => void;

  /**
   * Card list props
   */
  cardProps: {
    paymentMethods: PaymentMethod[];
  };

  /**
   * ACH list props
   */
  achProps?: AchProps;
};

export const PaymentMethodListUI = (props: PaymentMethodListUIProps) => {
  const { t } = useTranslation('payments');

  const {
    isLoading,
    addCardButton,
    addAchButton,
    addAchEnabled,
    onClickAddCard,
    onClickAddAch,
    className,

    selectedPaymentMethod,

    cardProps,
    onClickDelete,
    onSelectPaymentMethod,

    showAchList,
    achProps,
  } = props;

  return (
    <VerticalGrid className={classNames('payment-methods__list-ui', className)}>
      <Heading level={2}>{t('Card on File')}</Heading>
      <PaymentMethodListCard
        {...cardProps}
        isLoading={isLoading}
        selectedPaymentMethod={selectedPaymentMethod}
        onSelectPaymentMethod={onSelectPaymentMethod}
        onClickDelete={onClickDelete}
      />
      {addCardButton ?? (
        <Button
          variant='secondary'
          iconName='plus-small'
          css={{ width: 'max-content' }}
          disabled={isLoading}
          onClick={onClickAddCard}
        >
          {t('Add New Card')}
        </Button>
      )}
      {showAchList && !!achProps && (
        <>
          <Heading level={2}>{t('ACH on File')}</Heading>
          <PaymentMethodListAch
            {...achProps}
            isLoading={isLoading}
            selectedPaymentMethod={selectedPaymentMethod}
            onSelectPaymentMethod={onSelectPaymentMethod}
            onClickDelete={onClickDelete}
          />
          {addAchEnabled && (
            <>
              {addAchButton ?? (
                <Button
                  variant='secondary'
                  iconName='plus-small'
                  css={{ width: 'max-content' }}
                  disabled={isLoading}
                  onClick={onClickAddAch}
                >
                  {t('Add New ACH')}
                </Button>
              )}
            </>
          )}
        </>
      )}
    </VerticalGrid>
  );
};
